"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = require("graphql-tag");
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
exports.fetchTestDevices = () => (dispatch) => {
    const query = graphql_tag_1.default `
            query FetchTestDevices($predicates: String!, $pageNumber: Int, $pageSize: Int, $condition: String) {
                segmentFromPredicates(
                    predicates: $predicates
                    pageNumber: $pageNumber
                    pageSize: $pageSize
                    condition: $condition
                ) {
                    dataGridRows
                    segmentSize
                    totalSize
                }
            }
        `;
    const request = {
        query: query,
        variables: {
            predicates: '[{"attribute":"isTestDevice","booleanComparison":"is equal","selector":"DEVICE", \
            "booleanValue":true,"__typename":"BooleanPredicate","label":"Test Device?","options":[]}]',
            pageNumber: 0,
            pageSize: 150,
            condition: 'ANY',
        },
    };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_TEST_DEVICES_FAILURE', dispatch, errors[0].message);
        }
        else {
            let testDevices = [];
            data.segmentFromPredicates.dataGridRows.forEach((elem) => {
                testDevices.push({
                    deviceIdentifier: elem.find((v) => v.attribute === 'deviceIdentifier').value,
                    deviceName: elem.find((v) => v.attribute === 'deviceName').value,
                    createdAt: new Date(elem.find((v) => v.attribute === 'createdAt').value),
                });
            });
            testDevices.sort((a, b) => {
                if (a['createdAt'] < b['createdAt']) {
                    return 1;
                }
                if (a['createdAt'] > b['createdAt']) {
                    return -1;
                }
                return 0;
            });
            return dispatch({
                type: 'FETCH_TEST_DEVICES_SUCCESS',
                testDevices,
            });
        }
    }, ({ result }) => handleError_1.default('FETCH_TEST_DEVICES_FAILURE', dispatch, result.errors[0].message));
};
exports.updateSelectedTestDevices = (deviceIds) => (dispatch) => {
    dispatch({
        type: 'UPDATE_SELECTED_TEST_DEVICES',
        deviceIds,
    });
};
exports.deleteTestDevices = (deviceIds) => (dispatch) => {
    const query = graphql_tag_1.default `
            mutation deleteDevices($deviceIdentifiers: [ID!]!) {
                devicesDelete(deviceIdentifiers: $deviceIdentifiers)
            }
        `;
    const request = {
        query,
        variables: { deviceIdentifiers: deviceIds },
    };
    return Environment_1.default(request)
        .then(({ errors }) => {
        if (errors) {
            return handleError_1.default('DELETE_TEST_DEVICES_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'DELETE_TEST_DEVICES_SUCCESS',
            deviceIdentifiers: deviceIds,
        });
    })
        .catch(({ result }) => handleError_1.default('DELETE_TEST_DEVICES_FAILURE', dispatch, result.errors[0].message));
};
